import { useCallback } from 'react';
import { useSWRConfig } from 'swr';

const PENDING_MESSAGE_PATHS = new Set([
    '/organizations/{organization_id}/conversations/pending-messages',
    '/organizations/{organization_id}/conversations/pending-messages-count',
]);

function isPendingMessageQueryKey(key: unknown): boolean {
    return (
        Array.isArray(key) &&
        key[0] === 'get' &&
        typeof key[1] === 'string' &&
        PENDING_MESSAGE_PATHS.has(key[1])
    );
}

export function useInvalidatePendingMessageQueries(): () => void {
    const { mutate: mutateCache } = useSWRConfig();
    return useCallback(() => {
        void mutateCache((key) => isPendingMessageQueryKey(key));
    }, [mutateCache]);
}
